import {loadProductJson} from '@/product/product-selection/load-product-json';
import {h} from 'preact';
import register from 'preact-custom-element';
import ProductImageCarousel from './ProductImageCarousel';
import CarouselImagesSignal from '@/otp-gifts/carousel-images-signal';

function loader({product: productJson}: ProductImageCarouselLoaderProps) {
  loadProductJson(productJson);
  const carouselImagesSignal = new CarouselImagesSignal()

  // Removes placeholder from this component
  document?.getElementById("carousel-otp-gifts-placeholder")?.classList?.add("hidden")

  const images = carouselImagesSignal.getImages()

  return images.length > 0
    ? h(ProductImageCarousel, {
        images,
        featured: images[0],
      })
    : null;
}

register(loader, 'product-image-carousel-otp-gifts', ['product']);

type ProductImageCarouselLoaderProps = {
  product: string;
};
